import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomTranslationsService, STATE } from 'src/app/operational-data-common/translations';

import {
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  HeatingRodHeatingCommands,
  HeatingRodHeatingProperties,
  HeatingRodStatisticsProperties,
  HeatingRodStatusProperties,
  HeatingRodsHeatGenerationEntityCommands,
  HeatingRodsHeatGenerationEntityProperties,
} from '@vi-iot/client';

import { Helpers, InstallationFeaturesStore, RichDevice } from '@store';

import { SUFFIX } from '../../../shared/common/units';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-electric-heater',
  templateUrl: './electric-heater.component.html',
  styleUrls: ['./electric-heater.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElectricHeaterComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  heatingRodHeating$: Observable<
    Feature<HeatingRodsHeatGenerationEntityProperties, HeatingRodsHeatGenerationEntityCommands>
  >;
  heatingRodStatus$: Observable<Feature<HeatingRodStatusProperties, never>>;
  heatingConfigurationDhwHeater$: Observable<
    Feature<HeatingRodHeatingProperties, HeatingRodHeatingCommands>
  >;
  heatingRodStatistics$: Observable<Feature<HeatingRodStatisticsProperties, never>>;

  availableOverlays = FeaturesDetailsOverlayTypeEnum;
  getHeatingRodStatusValue = Helpers.getHeatingRodStatusValue;
  STATE = STATE;
  SUFFIX = SUFFIX;

  @Input({ required: true }) device: RichDevice;
  @Input({ required: true }) heatingRodIndex: string;

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    protected customTranslationsService: CustomTranslationsService
  ) {}

  ngOnInit(): void {
    this.heatingRodHeating$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingRodsHeatGenerationEntity(this.heatingRodIndex),
      this.device.id
    );

    this.heatingRodStatus$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingRodsHeatGenerationStatus(this.heatingRodIndex),
      this.device.id
    );

    this.heatingConfigurationDhwHeater$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingConfigurationDhwHeater,
      this.device.id
    );

    this.heatingRodStatistics$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.heatingRodStatistics(this.heatingRodIndex),
      this.device.id
    );
  }
}
